import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { useSpring, animated } from 'react-spring';
import { useLang } from './LanguageContext';
import t from './translations';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const { lang } = useLang();
  const { projects: proj } = t[lang];
  const animation = useSpring({ opacity: 1, from: { opacity: 0 } });

  useEffect(() => {
    import('./projects.json').then((data) => setProjects(data.default));
  }, []);

  return (
    <animated.section id="projects" style={animation}>
      <h2 className="work-heading">{proj.heading}</h2>
      <div className="projects-list">
        {projects.map((project, index) => (
          <div className="project" key={index}>
            <h3 className="work-title">{project.title}</h3>
            <p>{project.description}</p>
            <a href={project.link} target="_blank" rel="noopener noreferrer">
              {proj.viewOn}
              <FontAwesomeIcon icon={faGithub} style={{ marginLeft: '5px' }} />
            </a>
          </div>
        ))}
      </div>
    </animated.section>
  );
};

export default Projects;
